module.exports = __webpack_public_path__ + "static/media/logoAujude_vermelho_small.22011fa8.png";